import { REPORT_TEMPLATE, type IReportCardInfo, type CustomCardInfo } from '@/types';
import type { BaseCardService } from './abstract-base-card-service';
import { BaseCardServiceImpl, type BaseReportCardData } from './abstract-base-card-service';
import _ from 'lodash'
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { ReportApiService } from '@/infrastructure/api-functions/report-api-service';

export const CustomService = Symbol('CustomService');

export type CustomService = BaseCardService<CustomCardInfo>

@injectable()
export class CustomServiceImpl extends BaseCardServiceImpl<CustomCardInfo> implements CustomService {
    _modelData = {
        isLoading: false,
        isFailed: false,
        isSuccess: false,
        data: undefined,
    };

    templateType = REPORT_TEMPLATE.CUSTOM_MODULE;

    constructor(
    @inject(ReportApiService) _reportApiService: ReportApiService
    ) {
        super(
            _reportApiService
        );
    }

    updateFetchData(getUpdateValue: (v: BaseReportCardData<IReportCardInfo>) => BaseReportCardData<IReportCardInfo>): void {
        const updatedValue = getUpdateValue(_.omit(this.modelData, 'data'));

        const dataHaveFromUpdated = _.has(updatedValue, 'data')
        if (dataHaveFromUpdated) {
            const data = updatedValue.data?.[REPORT_TEMPLATE.CUSTOM_MODULE]
            this.update(modelData => ({
                ...modelData,
                ...updatedValue,
                data,
            }));
        } else {
            this.update(m => ({
                ...m,
                ...updatedValue,
                data: m.data,
            }));
        }
    }
}
